const SESSION_MESSAGES_IDS = {
  openPalletAlert: 'openPalletAlert',
}

const sessionMessages = [
  {
    id: SESSION_MESSAGES_IDS.openPalletAlert,
    readed: false,
  },
]

export { SESSION_MESSAGES_IDS, sessionMessages }
